// Pure decision helper for the end-of-phrase biased-LM-graph preparation (TT-1283).
// Extracted from ReaderManager so the story-relative index and skip guards are unit
// tested without the component's dependency graph.

/**
 * Which STORY-relative phrase index (if any) to prepare a biased LM graph for at the end
 * of the current phrase, or null when preparation should be skipped.
 *
 * The index is story-relative on purpose: onErrorsAreValid's `phrases` is the current
 * PAGE and its currentPhraseIndex is page-relative, but the CDN graph file
 * (`<storyId>_<overallIndex>.fst`) and the server-placement decision are keyed on the
 * story-wide index. Preparing `currentOverallPhraseIndex + 1` and bounding it against the
 * STORY phrase count is what makes page-first phrases (and one-phrase-per-page picture /
 * early-reader stories) covered rather than silently skipped.
 *
 * @param {object} params
 * @param {string} params.storyId
 * @param {boolean} params.retry Whether this is a retry/readback (no next phrase to prep).
 * @param {number} params.currentOverallPhraseIndex Story-relative index of the phrase that just ended.
 * @param {number} params.phraseCount Total phrases in the STORY.
 * @param {boolean} params.usesLocalAsr Whether the session uses local ASR (else nothing to route around).
 * @returns {number|null} The next story-relative phrase index to prepare, or null to skip.
 */
export function nextPhraseGraphPrepTarget({
  storyId,
  retry,
  currentOverallPhraseIndex,
  phraseCount,
  usesLocalAsr,
}) {
  if (!storyId || retry || !usesLocalAsr || !Number.isInteger(phraseCount)) {
    return null;
  }
  const nextPhraseIndex = Number(currentOverallPhraseIndex) + 1;
  if (!Number.isInteger(nextPhraseIndex) || nextPhraseIndex < 1 || nextPhraseIndex >= phraseCount) {
    return null;
  }
  return nextPhraseIndex;
}
